<template>
<div class="evaluate-container">
    <ul class="choose" v-if="!isNextStep">
        <div class="title">请对我们的服务做出评价</div>
        <li v-for="item in choices" class="choose-item" @click="setEvaluate(item.key)">
            <section class="circle" v-if="item.key === currentKey">
                <div class="inner"></div>
            </section>
            <div class="unselected" v-else></div>
            <div class="content">{{item.value}}</div>
        </li>
    </ul>
    <ul class="choose" v-else>
        <div class="title">我们需要改进的方向是</div>
        <li v-for="item in improves" class="choose-item" @click="setImproveKey(item.key)">
            <section class="circle" v-if="item.key === improveKey">
                <div class="inner"></div>
            </section>
            <div class="unselected" v-else></div>
            <div class="content">{{item.value}}</div>
        </li>
    </ul>
    <div class="submit">
        <button class="cancel" v-if="!isNextStep" @click="cancel">取消</button>
        <button class="cancel" v-else @click="backLastStep">返回上一步</button>
        <button class="confirm" @click="submit">提交</button>
    </div>
</div>
</template>

<script>
import fetchData from "@/utils/fetch";
import { Toast } from 'vant';
export default {
  props: {
    currentNum: String,
    value: Boolean
  },
  data() {
    return {
      currentKey: "1",
      improveKey: "1",
      isNextStep: false,
      choices: [
        {
          key: "1",
          value: "非常满意"
        },
        {
          key: "2",
          value: "满意"
        },
        {
          key: "3",
          value: "一般"
        },
        {
          key: "4",
          value: "不满意"
        },
        {
          key: "5",
          value: "非常不满意"
        }
      ],
      improves: [
        {
          key: "1",
          value: "客服态度"
        },
        {
          key: "2",
          value: "处理时效"
        },
        {
          key: "3",
          value: "处理结果"
        }
      ]
    };
  },
  methods: {
    setEvaluate(key) {
      this.currentKey = key;
    },
    setImproveKey(key) {
      this.improveKey = key;
    },
    cancel(params) {
      this.$emit("input", false);
    },
    backLastStep(params) {
      this.isNextStep = false;
    },
    ajaxSubmit(options) {
        fetchData('submitEvaluate', options).then((result) => {
            this.cancel();
            Toast('评价成功');
            this.$emit('refresh');
        }).catch((err) => {
            
        });
    },
    submit() {
      let options = { num: this.currentNum, level: this.currentKey };
      if (Number(this.currentKey) > 2) {
          if (!this.isNextStep) {
              this.isNextStep = true;
              return;
          }
          options.improve = this.improveKey;
          this.ajaxSubmit(options);
      } else {
          this.ajaxSubmit(options);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.evaluate-container {
  width: 468px;
  height: 540px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  padding: 52px 26px 24px;
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  top: 256px;
  transform: translateX(-50%);
  
  .choose {
    .title {
    font-weight: bold;
    // text-align: center;
    padding-left: 78px;
    font-size: 28px;
  }
    .choose-item {
      display: flex;
      align-items: center;
      margin-top: 24px;
      margin-left: 78px;
      .circle {
        width: 32px;
        height: 32px;
        border: 2px solid #f55c20;
        background: white;
        border-radius: 50%;
        position: relative;
        margin-right: 16px;
        .inner {
          width: 18px;
          height: 18px;
          background: #f55c20;
          position: absolute;
          left: 50%;
          top: 50%;
          border-radius: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .unselected {
        width: 32px;
        height: 32px;
        border: 2px solid rgba(0, 0, 0, 0.15);
        background: white;
        border-radius: 50%;
        position: relative;
        margin-right: 16px;
      }
      .content {
        color: #666;
      }
    }
  }
  .submit {
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 418px;
    bottom: 20px;
    .cancel {
      width: 200px;
      height: 64px;
      // background: #feda6a;
      border-radius: 6px;
      border: 2px solid #feda6a;
    }
    .confirm {
      width: 200px;
      height: 64px;
      background: #feda6a;
      border-radius: 6px;
      // border: 2px solid #feda6a;
    }
  }
}
</style>
